import React, { ReactElement, useEffect, useRef, FC } from 'react'

import { SeatsPerParty } from 'types/gemeindeRatSitzeFile'
import { ParliamentTableRow } from './parliamentTableRow'
interface Props {
  seatsPerParty: SeatsPerParty
}
export const ParliamentTable: FC<Props> = ({ seatsPerParty }): ReactElement => {
  const sortedSeatsPerParty = seatsPerParty.sort(
    (resultA, resultB) => resultB.seats - resultA.seats
  )
  return (
    <div id='parliament-table'>
      <div id='table-head'>
        <div>Parti</div>
        <div>Sièges</div>
      </div>
      <div>
        {sortedSeatsPerParty.map(row => (
          <ParliamentTableRow
            key={row.party}
            color={row.color}
            party={row.party}
            seatsNew={row.seats}
            seatsDisplay={row.seatsDisplay}
            seatsChange={row.changeSeats}
          />
        ))}
      </div>
      <small>
        <b>Note</b>: dans son calcul des résultats, le gouvernement français ne
        tient pas compte des voix recueillies par les candidats d’outre-mer
        rattachés à la NUPES. Cette visualisation emploie l’étiquetage{' '}
        <a
          target='_blank'
          rel='noreferrer'
          href='https://www.lemonde.fr/les-decodeurs/article/2022/06/01/comment-le-monde-attribue-les-nuances-politiques-aux-candidats-aux-legislatives-2022_6128494_4355770.html'
        >
          réalisé par «Le Monde» et diffusé en <i>open data</i>
        </a>
        .
      </small>
    </div>
  )
}
